import React from 'react'
import { Form } from 'semantic-ui-react'

export default class TitleField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Input
        fluid
        label="Title"
        placeholder="e.g New Promotion"
        required
        onChange={e => onChange('title', e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/titleField.js